import { InfoPagesRs } from '@domain/rs/info/InfoPagesRs';
import { InfoCategoryType } from '@domain/rs/info/InfoCategoryListRs';
import { PrivacyType } from '@domain/constant/privacyType';

export enum InfoContentType {
  TEXT = 'TEXT',
  VIDEO = 'VIDEO',
  LIVE = 'LIVE',
}

export interface InfoCardRs {
  categoryIconType: InfoCategoryType;
  categoryName: string;
  label: string;
  privacy: PrivacyType;
  sn: number;
  thumbnailUrl: string;
  title: string;
  type: InfoContentType;
}

export interface InfoCardListRs {
  pages: InfoPagesRs;
  posts: InfoCardRs[];
}
